var i18nLib = require("../i18n");

window.accordionToggleClickHandler = function (event) {
	const accordion = document.querySelector(".sidepanel__accordion");
	const accordionToggle = document.querySelector(".sidepanel__accordion .sidepanel__header-details");
	const accordionContent = document.querySelector(".sidepanel__body");
	const accordionLabel = document.querySelector(".sidepanel__accordion-label");

	if (!event.target.closest(".sidepanel__accordion .sidepanel__header-details")) return;

	const isExpanded = accordion.getAttribute("aria-expanded") === "true";
	accordion.setAttribute("aria-expanded", !isExpanded);
	accordionContent.classList.toggle("show");

	if (isExpanded) {
		accordionLabel.textContent = i18nLib.localize("show_details");
		document.body.style.overflow = ""; // Restore body scroll
		accordionContent.style.overflowY = ""; // Reset internal scrolling
	} else {
		accordionLabel.textContent = i18nLib.localize("hide_details");
		document.body.style.overflow = "hidden"; // Prevent background scroll
		accordionContent.style.overflowY = "auto"; // Allow scrolling in the sidepanel
	}

	// Retain focus on the accordion toggle (not the first item)
	accordion.focus();
};

window.accordionToggleKeydownHandler = function () {
	const accordionToggle = document.querySelector(".sidepanel__accordion .sidepanel__header-details");
	if (event.key === "Enter" || event.key === " ") {
		event.preventDefault();
		accordionToggle.dispatchEvent(new Event('click')); // Trigger click on keyboard interaction
	}
}

// Trap focus inside sidepanel
function trapFocus (element) {
	const focusableElements = element.querySelectorAll(
		'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
	);
	if (focusableElements.length === 0) return;

	const firstFocusable = focusableElements[0];
	const lastFocusable = focusableElements[focusableElements.length - 1];

	firstFocusable.focus();

	function handleTrap (event) {
		if (event.key === "Tab") {
			if (event.shiftKey && document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			} else if (!event.shiftKey && document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		} else if (event.key === "Escape") {
			event.preventDefault();
			accordionToggleClickHandler(); // Close panel on Escape
			document.querySelector(".sidepanel__accordion").focus(); // Restore focus to button
		}
	}

	element.addEventListener("keydown", handleTrap);
	element.dataset.trapListener = true; // Mark as having a listener
}

// Remove focus trap
function removeFocusTrap () {
	const sidepanel = document.querySelector(".sidepanel__body");
	if (sidepanel && sidepanel.dataset.trapListener) {
		sidepanel.removeEventListener("keydown", trapFocus);
		delete sidepanel.dataset.trapListener;
	}
}

window.runSidepanelEvents = function () {

	// Adjust width for `.value-size`
	function adjustWidths () {
		const values = document.querySelectorAll('.value-size');
		let maxDigitsValues = 0;

		// Calculate max width based on the largest number
		values.forEach(value => {
			maxDigitsValues = Math.max(maxDigitsValues, value.textContent.length);
		});

		// Apply width adjustments
		values.forEach(value => {
			if (value.classList.contains('currency-value-with-decimals')) {
				value.style.width = `${maxDigitsValues}ch`;
			} else {
				value.style.width = `${maxDigitsValues}ch`;
			}
		});

		const totalPriceValues = document.querySelectorAll('.totalprice-value-size');
		let maxDigitsTotalPrice = 0;

		// Calculate max width based on the largest number
		totalPriceValues.forEach(totalPriceValue => {
			maxDigitsTotalPrice = Math.max(maxDigitsTotalPrice, totalPriceValue.textContent.length);
		});

		// Apply width adjustments
		totalPriceValues.forEach(totalPriceValue => {
			if (totalPriceValue.classList.contains('currency-value-with-decimals')) {
				totalPriceValue.style.width = `${maxDigitsTotalPrice + 1}ch`;
			} else {
				totalPriceValue.style.width = `${maxDigitsTotalPrice + 1}ch`;
			}
		});
	}

	// Run initially
	adjustWidths();

	// Observe changes in the DOM for dynamically added classes or elements
	const observer = new MutationObserver(() => {
		adjustWidths(); // Re-run width adjustment when the DOM changes
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});

	// Copy currency select-mobile to select-mobile_placeholder
	const selectMobilePlaceHolder = document.getElementById('sidepanel-price-details-select-mobile_placeholder')
	const selectMobile = document.getElementById('sidepanel-price-details-select-mobile')
	const selectMobileInnerHtml = selectMobile && selectMobile.innerHTML
	if (selectMobilePlaceHolder && selectMobileInnerHtml) selectMobilePlaceHolder.innerHTML = selectMobileInnerHtml

	// Accordion toggle functionality
	const accordionToggle = document.querySelector(".sidepanel__accordion .sidepanel__header-details");
	const accordionContent = document.querySelector(".sidepanel__body");

	if (accordionToggle && accordionContent) {
		// Initialize the accordion functionality
		accordionToggle.removeEventListener("click", window.accordionToggleClickHandler);
		accordionToggle.addEventListener("click", window.accordionToggleClickHandler);

		accordionToggle.removeEventListener("keydown", window.accordionToggleKeydownHandler);
		accordionToggle.addEventListener("keydown", window.accordionToggleKeydownHandler);
	}



	// Helper functions
	const toggleClass = (element, className, condition) => {
		if (!element) return;
		if (condition) {
			element.classList.add(className);
		} else {
			element.classList.remove(className);
		}
	};

	// Variables
	const sidepanelPrice = document.querySelector(".sidepanel__price-details--total");
	const sidepanelPriceBanner = document.querySelector(".sidepanel__price-banner");
	const sidepanelSaveDetails = document.querySelector(".sidepanel__save-details");
	// const hasFooter = document.querySelector("footer");
	const sidepanelBody = document.querySelector(".sidepanel__body");
	const bookingSection = document.querySelector("#booking-page-layout");

	const updateSidepanelMaxHeight = () => {
		if (window.innerWidth < 1240) return; // Only run for 1240px and above

		if (bookingSection) {
			sidepanelBody.style.maxHeight = `${bookingSection.offsetHeight - 75}px`;
		}
	};

	// Use ResizeObserver to watch for body size changes (only if width >= 1240px)
	const bodyResizeObserver = new ResizeObserver(() => {
		if (window.innerWidth >= 1240) {
			updateSidepanelMaxHeight();
		}
	});

	// Start observing changes in the booking section (only if width >= 1240px)
	if (window.innerWidth >= 1240 && bookingSection) {
		bodyResizeObserver.observe(bookingSection);
	}

	// Ensure the correct initial state (only if width >= 1240px)
	if (window.innerWidth >= 1240) {
		updateSidepanelMaxHeight();
	}


	const updateBannerVisibility = () => {
		if (!sidepanelPrice || !sidepanelPriceBanner) return;

		const rect = sidepanelPrice.getBoundingClientRect();

		let isOnScreen = rect.top >= 0 && rect.bottom <= window.innerHeight;
		let shouldShowBanner = !isOnScreen;

		// Update the class of the banner
		toggleClass(sidepanelPriceBanner, "show-banner", shouldShowBanner);

	};


	// Mutation observer for sidepanel content updates
	const sidepanel = document.querySelector(".sidepanel");
	if (sidepanel) {
		const mutationObserver = new MutationObserver(() => {
			// Reevaluate banner visibility on content updates
			updateBannerVisibility();
		});

		mutationObserver.observe(sidepanel, {
			childList: true,
			subtree: true,
		});
	}

	// Debounce function for scroll/resize events
	const debounce = (func, wait) => {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func(...args), wait);
		};
	};

	// Event listeners for scroll and resize
	const debouncedUpdateBannerVisibility = debounce(updateBannerVisibility, 50); // Reduced debounce time
	window.addEventListener("scroll", debouncedUpdateBannerVisibility);
	window.addEventListener("resize", debouncedUpdateBannerVisibility);

	// Monitor sidepanel body scroll
	if (sidepanelBody) {
		sidepanelBody.addEventListener("scroll", debouncedUpdateBannerVisibility);
	}

	// Ensure correct initial state
	updateBannerVisibility();

	// Campaign code drawer
	var campaignToggle = document.getElementById('campaignCodeToggle');
	var campaignDrawer = document.getElementById('campaignCodeDrawer');
	var campaignApplyBtn = document.getElementById('campaignApplyBtn');
	var campaignRemoveBtn = document.getElementById('campaignRemoveBtn');
	var campaignInput = document.getElementById('campaignCodeInput');
	var campaignCodeDisplay = document.getElementById('campaignCodeDisplay');
	var campaignInputState = document.getElementById('campaignInputState');
	var campaignConfirmationState = document.getElementById('campaignConfirmationState');
	var campaignToggleLabel = document.getElementById('campaignCodeToggleLabel');
	var campaignHiddenInput = document.querySelector("input[name='campaignCode']");
	var campaignToggleLabelHave = campaignToggle && campaignToggle.getAttribute('data-label-have');
	var campaignToggleLabelRemove = campaignToggle && campaignToggle.getAttribute('data-label-remove');

	if (campaignToggle && campaignDrawer && campaignApplyBtn && campaignRemoveBtn && campaignInput && campaignCodeDisplay && campaignInputState && campaignConfirmationState && campaignToggleLabel) {
		var applyCampaignCode = function (code) {
			var safeCode = (code || '').trim();
			if (!safeCode) return;
			campaignInput.value = safeCode;
			campaignCodeDisplay.textContent = safeCode;
			if (campaignHiddenInput) {
				campaignHiddenInput.value = safeCode;
			}
			campaignInputState.style.display = 'none';
			campaignConfirmationState.classList.add('visible');
			campaignToggleLabel.textContent = campaignToggleLabelRemove || campaignToggleLabel.textContent;
		};

		var removeCampaignCode = function () {
			campaignInput.value = '';
			campaignCodeDisplay.textContent = '';
			if (campaignHiddenInput) {
				campaignHiddenInput.value = '';
			}
			campaignConfirmationState.classList.remove('visible');
			campaignInputState.style.display = '';
			campaignToggleLabel.textContent = campaignToggleLabelHave || campaignToggleLabel.textContent;
		};

		// Keep UI aligned with current hidden value when sidepanel is refreshed.
		applyCampaignCode(campaignHiddenInput && campaignHiddenInput.value);

		if (campaignDrawer.getAttribute('data-campaign-bound') === 'true') {
			return;
		}
		campaignDrawer.setAttribute('data-campaign-bound', 'true');

		campaignToggle.addEventListener('click', function () {
			var isOpen = campaignDrawer.classList.toggle('open');
			campaignToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		});

		campaignApplyBtn.addEventListener('click', function () {
			applyCampaignCode(campaignInput.value);
		});

		campaignRemoveBtn.addEventListener('click', function () {
			removeCampaignCode();
		});
	}
}



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/sidepanel.js